import { Stack } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

export function CancellationProtectionLabel() {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <CbhIcon type="parachute" size="xSmall" />
      <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.primary })}>
        Cancellation Protection
      </Text>
    </Stack>
  );
}
